import 'regenerator-runtime/runtime'
const fs = require('fs')

export const RECEIVE_TRAIN_POSITION = 'RECEIVE_TRAIN_POSITION'
export const RECEIVE_JR_TRAIN_POSITION = 'RECEIVE_JR_TRAIN_POSITION'
export const RECEIVE_STATION_DETAIL = 'RECEIVE_STATION_DETAIL'
export const RECEIVE_TRAIN_DETAIL = 'RECEIVE_TRAIN_DETAIL'
export const RECEIVE_JR_TRAIN_DETAIL = 'RECEIVE_JR_TRAIN_DETAIL'
export const RECEIVE_TOKYU_TRAIN_POSITION = 'RECEIVE_TOKYU_TRAIN_POSITION'
export const RECEIVE_SHINYOKOHAMA_TRAIN_INFO = 'RECEIVE_SHINYOKOHAMA_TRAIN_INFO'
export const CLOSE_TRAIN_MODAL = 'CLOSE_TRAIN_MODAL'
export const CLOSE_TRANSFER_MODAL = 'CLOSE_TRANSFER_MODAL'
export const CLOSE_KIND_MODAL = 'CLOSE_KIND_MODAL'
export const OPEN_TRAIN_SELECT_MODAL = 'OPEN_TRAIN_SELECT_MODAL'
export const CLOSE_TRAIN_SELECT_MODAL = 'CLOSE_TRAIN_SELECT_MODAL'
export const LOADED_DELAY_CERTIFICATES = 'LOADED_DELAY_CERTIFICATES'
export const LOADED_ANNOUNCEMENT = 'LOADED_ANNOUNCEMENT'
export const RECEIVE_LOCATION_DATA = 'RECEIVE_LOCATION_DATA'
export const RECEIVE_CURRENT_CONGESTION_RATE = 'RECEIVE_CURRENT_CONGESTION_RATE'
export const RECEIVE_CONGESTION_TREND = 'RECEIVE_CONGESTION_TREND'
export const CHANGE_TIMETABLE_COLLAPSED = 'CHANGE_TIMETABLE_COLLAPSED'
export const SET_THEME = 'SET_THEME'
export const SET_OS = 'SET_OS'
export const SET_POPINFO_ID = 'SET_POPINFO_ID'
export const SET_APP_VERSION = 'SET_APP_VERSION'
export const SET_USER_SETTINGS = 'SET_USER_SETTINGS'
export const RECEIVE_USER_SETTINGS = 'RECEIVE_USER_SETTINGS'

const API_BASE_URL = process.env.API_BASE_URL
const EXTERNAL_DATA_BASE_URL = process.env.EXTERNAL_DATA_BASE_URL
const EXTERNAL_SIGNATURE_API_BASE_URL = process.env.EXTERNAL_SIGNATURE_API_BASE_URL
const STATION_VIEW_DATA_BASE_URL = 'https://external-data.sotetsuapp.com'

export const receiveTrainPosition = payload => ({
  type: RECEIVE_TRAIN_POSITION,
  payload,
})

export const receiveJrTrainPosition = payload => ({
  type: RECEIVE_JR_TRAIN_POSITION,
  payload,
})

export const receiveStationDetail = payload => ({
  type: RECEIVE_STATION_DETAIL,
  payload,
})

export const receiveTokyuTrainPosition = (payload, lineSymbol) => ({
  type: RECEIVE_TOKYU_TRAIN_POSITION,
  payload,
})

export const receiveShinyokohamaTrainInfo = (payload, operationNumber) => ({
  type: RECEIVE_SHINYOKOHAMA_TRAIN_INFO,
  payload,
  operationNumber,
})

export const receiveSingleTrain = (payload, tidTrain) => ({
  type: RECEIVE_TRAIN_DETAIL,
  payload,
  tidTrain,
})

export const receiveSingleJrTrain = (payload, tidTrain) => ({
  type: RECEIVE_JR_TRAIN_DETAIL,
  payload,
  tidTrain,
})

export const closeTrainModal = () => ({
  type: CLOSE_TRAIN_MODAL,
  showingTrain: null,
})

export const closeTransferModal = () => ({
  type: CLOSE_TRANSFER_MODAL,
})

export const closeKindModal = () => ({
  type: CLOSE_KIND_MODAL,
})

export const openTrainSelectModal = (selectingTrains) => ({
  type: OPEN_TRAIN_SELECT_MODAL,
  selectingTrains,
})

export const closeTrainSelectModal = () => ({
  type: CLOSE_TRAIN_SELECT_MODAL,
})

export const receiveLocationData = (payload, locationId) => ({
  type: RECEIVE_LOCATION_DATA,
  locationId,
  payload,
})

export const receiveCurrentCongestionRate = (payload, locationId) => ({
  type: RECEIVE_CURRENT_CONGESTION_RATE,
  locationId,
  payload,
})

export const receiveCongestionTrend = (payload, locationId) => ({
  type: RECEIVE_CONGESTION_TREND,
  locationId,
  payload,
})

export const receiveUserSettings = (payload) => ({
  type: RECEIVE_USER_SETTINGS,
  payload
})

export const setUserSettings = (payload) => ({
  type: SET_USER_SETTINGS,
  payload
})

export const loadedDelayCertificates = payload => ({
  type: LOADED_DELAY_CERTIFICATES,
  delayCertificates: payload.delay_certificates,
})

export const loadedAnnouncement = payload => ({
  type: LOADED_ANNOUNCEMENT,
  announcement: payload.announcement,
})

export const changeTimetableCollapsed = (index, isCollapsed) => ({
  type: CHANGE_TIMETABLE_COLLAPSED,
  index,
  isCollapsed,
})

export const setTheme = (themeName) => ({
  type: SET_THEME,
  themeName,
})

export const setOs = (osName) => ({
  type: SET_OS,
  osName,
})

export const setAppVersion = (appVersion) => ({
  type: SET_APP_VERSION,
  appVersion,
})

export const setPopinfoId = (popinfoId) => ({
  type: SET_POPINFO_ID,
  popinfoId,
})

const fetchJSON = async (url, popinfoId = null) => {
  const fetchParams = {
    mode: 'cors'
  }
  if (popinfoId){
    fetchParams['headers'] = { ...fetchParams['headers'], 'x-popinfo-id': popinfoId }
  }
  const response = await fetch(url, fetchParams)
  const json = await response.json()
  return json
}

const putJSON = async (url, data, popinfoId = null) => {
  const fetchParams = {
    method: 'put',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify(data)
  }
  if (popinfoId){
    fetchParams['headers'] = { ...fetchParams['headers'], 'x-popinfo-id': popinfoId }
  }
  const response = await fetch(url, fetchParams)
  return response
}

export const fetchTrains = () => fetchJSON(`${EXTERNAL_DATA_BASE_URL}/tid/trains.json?${+ new Date()}`)
export const fetchJrTrains = () => fetchJSON(`${EXTERNAL_DATA_BASE_URL}/tid/jr_train_location_info.json?${+ new Date()}`)
export const fetchTokyuPresignedUrl = (lineSymbol) => fetchJSON(`${EXTERNAL_SIGNATURE_API_BASE_URL}/external-data-url?key=${lineSymbol}.json`)
export const fetchPresignedJson = (url) => fetchJSON(url)

export const fetchShinyokohamaTrainInfo = (operationNumber) => fetchJSON(`${API_BASE_URL}/shinyokohama_train_info?operation_number=${operationNumber}`)

export const fetchSingleTrain = trainNumber => fetchJSON(`${API_BASE_URL}/trains/${trainNumber}/stop_stations`)
export const fetchSingleJrTrain = trainNumber => fetchJSON(`${EXTERNAL_DATA_BASE_URL}/tid/jr_train_detail_info.json?${+ new Date()}`)

// StationViewのデータは現在本番にしか投げ込まれていないので
// API_BASE_URL をつかわずに本番URLをいったん固定で埋め込んでおく
export const fetchLocationData = async (stationId, locationId) => {
  return fetchJSON(`${STATION_VIEW_DATA_BASE_URL}/station_view/stations/${stationId}/locations/${locationId}.json?${+ new Date()}`)
}

export const fetchCurrentCongestionRate = async (stationId, locationId) => {
  return fetchJSON(`${STATION_VIEW_DATA_BASE_URL}/station_view/stations/${stationId}/locations/${locationId}/current_congestion_rate.json?${+ new Date()}`)
}

export const fetchCongestionTrend = async (stationId, locationId) => {
  return fetchJSON(`${STATION_VIEW_DATA_BASE_URL}/station_view/stations/${stationId}/locations/${locationId}/congestion_trend.json?${+ new Date()}`)
}

export const fetchStationDetail = async (stationId) => fetchJSON(`${API_BASE_URL}/stations/${stationId}`)
export const fetchDelayCertificates = async () => fetchJSON(`${API_BASE_URL}/delay_certificates`)
export const fetchAnnouncement = async () => fetchJSON(`${API_BASE_URL}/announcement`)

export const fetchUserSettings = async (popinfoId) => fetchJSON(`${API_BASE_URL}/user_setting`, popinfoId)
export const putUserSettings = async (popinfoId, data) => putJSON(`${API_BASE_URL}/user_setting`, { user: data }, popinfoId)
